import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';
import {SearchProcedure} from 'domain/usecases/private/guide-flow/medical-guide/search-procedure';
import {RemoteSearchProcedure} from 'data/usecases/private/guide-flow/medical-guide/remote-search-procedure';

export const makeSearchProcedure = (): SearchProcedure =>
  new RemoteSearchProcedure(
    makeBFFApiUrl(GuideFlowEndpoints.medicalSearchProcedure),
    makeAuthorizeHttpClientDecorator(),
  );
